import { CircularProgress } from '@material-ui/core';
import { BetActionErrorResponseDataDto } from 'api/common.generated';
import { usePromoConditionsState } from 'features/PromoConditions';
import { FC } from 'react';
import { BalanceState, BETSType, PlaceBet } from 'shared/interface';
import AKOBet from '../ako';
import BetslipEmpty from '../BetslipEmpty';
import { CouponPanel } from '../CouponPanel/CouponPanel';
import CouponTabs from '../CouponTabs';
import SystemBet from '../SystemBet';
import './styles.scss';

interface Props {
	isAkoBetTab: boolean;
	bets: BETSType;
	balanceData: BalanceState;
	isBetslipEmpty: boolean;
	isCal: boolean;
	betStatics: any;
	stackValue: number;
	errorCode: number[];
	loading: boolean;
	freeBets: any[];
	selectedFreeBet: string;
	betLoading: boolean;
	betType: number;
	approvedSlip: boolean;
	betActionErrors: BetActionErrorResponseDataDto[];
	warnings: string[];
	completedEvents: string[];
	selectedBalanceType: string;
	outcomes: PlaceBet[];
	betMode: string;
	isSystemBetTab: boolean;
	blocks: PlaceBet[][];
	selectedCombination: string;
	awaitingWinningResp: boolean;
	isRestoringBets: boolean;
	temporaryBets: boolean;
	onChangeStackValue: (value: number) => void;
	handelSelectedBet: (isSelected: boolean, outcomeId: string) => void;
	handleOddsChangeOption: (value: string) => void;
	onClickPlaceBet: () => void;
	changeNavigationView: () => void;
	onCloseError: (error: number, indexOfErrorDetail: number) => void;
	handleIsRestoringBets: (isRestoring: boolean) => void;
	handleSelectedCombination: (value: string) => void;
	handleIsCal: (value: boolean) => void;
	removeBet: (outcomeId: string) => void;
	handleGroupChange: (outcomeId: string, newGroupIndex?: number | undefined) => void;
	deselectFreeBet: () => void;
	handelSelectedFreeBet: (id: string, stack: number) => void;
	onChangeGameMode: (mode: string) => void;
	deleteTemporaryBets: () => void;
	removeAllBets: () => void;
	handleHomeRedirection: () => void;
	setStakeMethod: (stake: string) => void;
}

const MobileCouponBasket: FC<Props> = ({
	bets,
	balanceData,
	isAkoBetTab,
	isBetslipEmpty,
	isCal,
	betActionErrors,
	betLoading,
	betStatics,
	betType,
	freeBets,
	selectedBalanceType,
	selectedFreeBet,
	stackValue,
	outcomes,
	loading,
	errorCode,
	betMode,
	approvedSlip,
	warnings,
	completedEvents,
	isSystemBetTab,
	blocks,
	selectedCombination,
	awaitingWinningResp,
	isRestoringBets,
	temporaryBets,
	handelSelectedBet,
	removeBet,
	onCloseError,
	handleSelectedCombination,
	onChangeStackValue,
	onClickPlaceBet,
	handleIsCal,
	handleIsRestoringBets,
	handleOddsChangeOption,
	handleGroupChange,
	deselectFreeBet,
	handelSelectedFreeBet,
	changeNavigationView,
	onChangeGameMode,
	setStakeMethod,
}) => {
	const promoConditionsState = usePromoConditionsState();
	return (
		<div className="MobileCouponBasket">
			<CouponTabs isBetslipEmpty={isBetslipEmpty} bets={bets} balanceData={balanceData} onChangeGameMode={onChangeGameMode} />
			<div className={`MobileCouponBasket__wrapper ${approvedSlip ? 'bet-disabled position--relative' : ''}`}>
				<div className="MobileCouponBasket__coupons coupon-content-wrapper">
					{approvedSlip && <CircularProgress color="primary" className="approved-slips-loader" />}
					{isBetslipEmpty && <BetslipEmpty promoConditionsState={promoConditionsState} />}
					{isAkoBetTab && !isBetslipEmpty && (
						<AKOBet
							promoConditionsState={promoConditionsState}
							setStakeMethod={setStakeMethod}
							isCal={isCal}
							handleIsCal={handleIsCal}
							allBets={outcomes}
							removeBet={removeBet}
							betStatics={betStatics}
							onChangeStackValue={onChangeStackValue}
							stackValue={stackValue}
							handelSelectedBet={handelSelectedBet}
							handleOddsChangeOption={handleOddsChangeOption}
							onClickPlaceBet={onClickPlaceBet}
							changeNavigationView={changeNavigationView}
							errorCode={errorCode}
							loading={loading}
							freeBets={freeBets}
							selectedFreeBet={selectedFreeBet}
							onCloseError={onCloseError}
							betLoading={betLoading}
							betType={betMode}
							approvedSlip={approvedSlip}
							betActionErrors={betActionErrors}
							warnings={warnings}
							completedEvents={completedEvents}
							selectedBalanceType={selectedBalanceType}
							handleIsRestoringBets={handleIsRestoringBets}
							bets={bets}
						/>
					)}

					{isSystemBetTab && (
						<SystemBet
							setStakeMethod={setStakeMethod}
							isCal={isCal}
							handleIsCal={handleIsCal}
							outcomes={outcomes}
							blocks={blocks}
							removeBet={removeBet}
							betStatics={betStatics}
							onChangeStackValue={onChangeStackValue}
							handelSelectedBet={handelSelectedBet}
							stackValue={stackValue}
							handleOddsChangeOption={handleOddsChangeOption}
							selectedCombination={selectedCombination}
							handleSelectedCombination={handleSelectedCombination}
							onClickPlaceBet={onClickPlaceBet}
							changeNavigationView={changeNavigationView}
							errorCode={errorCode}
							loading={loading}
							onCloseError={onCloseError}
							betLoading={betLoading || awaitingWinningResp}
							betType={betMode}
							approvedSlip={approvedSlip}
							betActionErrors={betActionErrors}
							warnings={warnings}
							completedEvents={completedEvents}
							handleGroupChange={handleGroupChange}
							isDesktop={false}
							handleIsRestoringBets={handleIsRestoringBets}
							bets={bets}
						/>
					)}

					<CouponPanel
						promoConditionsState={promoConditionsState}
						isCal={isCal}
						handleIsCal={handleIsCal}
						deselectFreeBet={deselectFreeBet}
						isBetslipEmpty={isBetslipEmpty}
						changeNavigationView={changeNavigationView}
						betStatics={betStatics}
						onClickPlaceBet={onClickPlaceBet}
						outcomes={outcomes}
						handleOddsChangeOption={handleOddsChangeOption}
						loading={loading}
						selectedCombination={selectedCombination}
						onChangeStackValue={onChangeStackValue}
						betLoading={betLoading}
						approvedSlip={approvedSlip}
						betMode={betMode}
						selectedBalanceType={selectedBalanceType}
						betType={betType}
						freeBets={freeBets}
						price={stackValue}
						blocks={blocks}
						awaitingWinningResp={awaitingWinningResp}
						selectedFreeBet={selectedFreeBet}
						handelSelectedFreeBet={handelSelectedFreeBet}
					/>
				</div>
			</div>
		</div>
	);
};

export default MobileCouponBasket;
